export enum NodeEnv {
  Development = 'development',
  PreProd = 'preprod',
  Production = 'production',
  Localhost = 'localhost',
}
